import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class Mgt2Service {

  constructor( private httpService: HttpService) { }


  samplemgt2Record(object) {
      console.log("object", object);
      var request = {
          URL: "mgt2/mgt2Entry",
          DATA: object
      }
      return this.httpService.post(request);
  }

  samplemgt2personalRecord(personal){
      console.log("object", personal);
      // return this.http.post(environment.pssUrl + 'Investment/ecsEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
      //         .map(res => res.json());
      var request = {
          URL: "mgt2/mgt2PersonalEntry",
          DATA: personal
      }
      return this.httpService.post(request);

  }
  samplemgt2holdingRecord(holding){
      console.log("object", holding);
      // return this.http.post(environment.pssUrl + 'Investment/ecsEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
      //         .map(res => res.json());
      var request = {
          URL: "mgt2/mgt2HoldingEntry",
          DATA: holding
      }
      return this.httpService.post(request);

  }
  getRegisterMgt2() {
      var registerList = {
              URL: "mgt2/getMgt2Details/5cee33d225242e023acfb2d4"
      }
      return this.httpService.get(registerList);
  }

  getMgt2SearchList(object) {
      var registerList = {
          URL: "mgt2/getMgt2List",
          DATA: object
      }
      return this.httpService.post(registerList);
  }

  removemgt2details(_id){
      var request = {
          URL: "mgt2/deletadetails/" + _id
      }
      return this.httpService.get(request);
  }
  updatemgt2(_id) {
      var editlist = {
          URL: "mgt2/update/" + _id,
      }
      return this.httpService.get(editlist);
  }
  updateSecParticulars(object, id) {
      var request = {
          URL: "mgt2/updateSecParticular/" +id,
          DATA: object
      }
      return this.httpService.post(request);
  }

  getDetailOfSecurity(_id) {
     
      var request = {
          URL: "mgt2/security-list/" + _id
         
      }
      return this.httpService.get(request);
  }
  update(_id, data){
      var request = {
      URL: "mgt2/security-details/" + _id,
      DATA: data
      }
      return this.httpService.post(request);

  }
  removedetails(_id) {
      var request = {
          URL: "mgt2/deleteSecurity/" + _id
      }
      return this.httpService.get(request);
  }   
  getSecurityDetails() {
      var request = {
          URL: "mgt2/getSecurityDetails/5cee33d225242e023acfb2d4",
             
      }
      return this.httpService.get(request);
     
  }
  SecurityDetail(securityObjects){
      console.log("securityObjects", securityObjects);

      var request = {
          URL: 'mgt2/addSecurityDetails',
          DATA: securityObjects
      }
      return this.httpService.post(request);
  }

  addDetailsOfSecurity(object)
  {
      var request = {
          URL: 'mgt2/addDetailsOfSecurity',
          DATA: object
      }
      return this.httpService.post(request);
  }

  getSecurityDetailsList(_id, searchParam)
  {
      var request = {
          URL: "mgt2/getSecurityDetailsList/" + _id,
          DATA: searchParam
      }
      return this.httpService.post(request);
  }

  deleteSecurityDetails(_id,Id)
  {
      var request = {
          URL: "mgt2/deleteSecurityDetails/" + _id + "/"+Id,
      }
      return this.httpService.get(request);
  }

  updateSecurityDetailsData(editData)
  {
      var request = {
          URL: 'mgt2/updateSecurityDetailsData',
          DATA: editData
      }
      return this.httpService.post(request);
  }

  generateMgt2Document(object) {
      var request = {
          URL: "mgt2/generateMgt2Document",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadMgt2File(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mgt2/downloadDocument/" + id + "/" + type + "/" + token;
  }
  downloadMgt2PdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mgt2/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }



}